import { createSelector } from "reselect";
import { filter, map, find, get } from "lodash";
import { RootState } from "../reducers";

export const selectTracks = (state: RootState) => state.tracks.tracks.data;

export const selectTracksFilteredCount = createSelector(
  selectTracks,
  tracks => tracks.length,
);

export const selectTracksPage = (state: RootState) => state.tracks.page;

export const selectTracksLoading = (state: RootState) => state.tracks.isLoading;

export const selectTracksNavLoading = (state: RootState) =>
  state.tracks.navLoading;

export const selectTracksMeta = (state: RootState) => state.tracks.tracks.meta;

export const selectTracksFilteredTotal = (state: RootState) =>
  state.tracks.filteredTotal;

export const selectTracksRecordCount = createSelector(
  selectTracksMeta,
  meta => meta && meta.recordCount,
);

export const selectTracksPageCount = createSelector(
  selectTracksMeta,
  meta => meta && meta.pageCount,
);

export const selectTracksIncluded = (state: RootState) =>
  state.tracks.tracks.included;

export const selectTracksIncludedUsers = createSelector(
  selectTracksIncluded,
  included => filter(included, related => related.type === "users"),
);

export const selectTracksIncludedCases = createSelector(
  selectTracksIncluded,
  included => filter(included, related => related.type === "cases"),
);

export const selectTracksIncludedCaseFollows = createSelector(
  selectTracksIncluded,
  included => filter(included, related => related.type === "caseFollows"),
);

export const selectTracksTableData = createSelector(
  selectTracks,
  selectTracksIncludedCases,
  (distributionLists, cases) =>
    map(distributionLists, distributionList => {
      const relatedCase = find(cases, distributionListCase => {
        const distributionListCaseId = get(
          distributionList,
          "relationships.case.data.id",
          "",
        );
        return distributionListCase.id === distributionListCaseId;
      });
      const relatedCaseFollows = get(
        distributionList,
        "relationships.members.data",
        [],
      );
      if (relatedCase) {
        return {
          distributionListId: distributionList.id,
          caseId: relatedCase.id,
          caseFollows: relatedCaseFollows,
          ...distributionList.attributes,
          ...relatedCase.attributes,
        };
      }
    }),
);
